import React, { Component } from 'react';
import Slide from 'react-reveal/Slide';
import { FiDownload } from 'react-icons/fi';
// import developerImg from '../assets/Developer.png';

export class Intro extends Component {
  render() {
    const tags = [
      'Html5',
      'Css3',
      'Scss',
      'Javascript',
      'React',
      'Redux',
      'Nextjs',
      'React-Native',
      'Git',
      'Nodejs',
      'Express',
      'Mongodb',
      // "Flutter/Dart",
      // 'Loopback',
    ];

    return (
      <section className='section about' id='about'>
        <div className='intro'>
          <Slide left>
            <div className='developer-pic'>
              <img src="/images/linkedin-programming.jpg" alt='Developer' className='pic' />
            </div>
          </Slide>
          <Slide right cascade>
            <div className='me'>
              <h3 className='h3 heading'>About Me</h3>
              <p className='description'>
                I am Avtar Prajapati, Mumbai based full-stack web developer and
                curiosity to solve challenging problems. and Building products
                are to excite and motivate me.
              </p>
              <ul className='tag'>
                {tags.map((tag, i) => (
                  <li key={i}>{tag}</li>
                ))}
              </ul>
              <a
                href="/assets/resume.pdf"
                className='link resume'
                download='Avtar_Prajapati_Resume.pdf'
              >
                <span>Download CV </span>
                <FiDownload />
              </a>
            </div>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Intro;
